import React from "react";
import {
  Box,
  Typography,
  TextField,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import { FileText } from "lucide-react";

const FONT_FAMILY =
  "'Inter', 'Inter Fallback', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

const TemplateSearchDropdown = ({
  label = "Select a Template",
  placeholder = "Search templates...",
  options = [],
  value,
  onChange,
  loading = false,
  disabled = false,
}) => {
  return (
    <Autocomplete
      fullWidth
      value={value || null}
      onChange={(event, newValue) => onChange(newValue)}
      options={options}
      loading={loading}
      disabled={disabled}
      getOptionLabel={(option) => option?.Name || ""}
      isOptionEqualToValue={(option, val) => option?.Name === val?.Name}
      noOptionsText="No templates available"
      loadingText="Loading templates..."
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          key={option.Name}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "12px 16px !important",
            "&:hover": {
              backgroundColor: "#F0F9FF",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              backgroundColor: "#F0F9FF",
              color: "#0073A6",
              flexShrink: 0,
            }}
          >
            <FileText size={16} />
          </Box>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#12243C",
              fontFamily: FONT_FAMILY,
            }}
          >
            {option.Name}
          </Typography>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress size={16} sx={{ color: "#0073A6", mr: 1 }} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      sx={{
        marginBottom: "2px",
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          backgroundColor: "#F8FAFC",
          borderColor: "#E2E8F0",
          "&:hover": {
            borderColor: "#CBD5E1",
          },
          "&.Mui-focused": {
            borderColor: "#0073A6",
            backgroundColor: "#FFFFFF",
          },
        },
        "& .MuiInputBase-input": {
          fontSize: "14px",
          fontFamily: FONT_FAMILY,
        },
        "& .MuiInputLabel-root": {
          fontSize: "14px",
          color: "#64748B",
          fontFamily: FONT_FAMILY,
          "&.Mui-focused": {
            color: "#0073A6",
          },
        },
      }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            border: "1px solid #F1F5F9",
            marginTop: "4px",
          },
        },
      }}
      ListboxProps={{
        sx: {
          maxHeight: "300px",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#F8FAFC",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#CBD5E1",
            borderRadius: "8px",
            "&:hover": {
              background: "#94A3B8",
            },
          },
        },
      }}
    />
  );
};

export default TemplateSearchDropdown;
